module.exports = __webpack_public_path__ + "img/btn-play-video.f7906134.png";